// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_fo-2";
export var aiChatCartContainerExit = "_fo-4";
export var aiChatContainerLarge = "_fo-0";
export var aiChatContainerSmall = "_fo-1";
export var aiChatIcon = "_fo-6";
export var slideInFromRight = "_fo-3";
export var slideOutToRight = "_fo-5";